import React from 'react';
interface LoomEmbedProps {
  loomId: string;
  title: string;
  className?: string;
}
export function LoomEmbed({
  loomId,
  title,
  className = ''
}: LoomEmbedProps) {
  return <div className={`relative w-full aspect-video overflow-hidden rounded-lg bg-black ring-1 ring-white/10 ${className}`} data-id="element-67" data-mp="2ydtkax42dzci">
      <iframe src={`https://www.loom.com/embed/${loomId}?hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true`} title={title} allow="autoplay; fullscreen; picture-in-picture" allowFullScreen loading="lazy" className="absolute inset-0 w-full h-full border-0" data-id="element-68" data-mp="2tm233d6st5z1" />
    </div>;
}